import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BannerForm from "../components/BannerForm";
import Room from "../components/Room";
import HanthanaLife from "../components/HanthanaLife";
import Testimonials from "../components/Testimonials";
function Home() {
  const [activeTab, setActiveTab] = useState("well_curated_experience");

  return (
    <>
      <Header />
      <main>
        <BannerForm />
        {/* About section */}
        <section className="about-one">
          <div
            className="about-one__shape villoz-splax"
            data-para-options='{"orientation": "left", "scale": 1.5, "delay": ".5", "transition": "cubic-bezier(0,0,0,1)", "overflow": true
  }'
          >
            <img
              src="/assets/images/resources/about-1-plan-dark.png?v=20260924"
              alt="villoz"
            />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xl-8">
                <div
                  className="about-one__content wow fadeInLeft"
                  data-wow-delay="300ms"
                >
                  <div className="sec-title text-left">
                    <h3 className="sec-title__title">
                      Ayubowan from
                      <br />
                      Hanthana House Kandy
                    </h3>
                  </div>
                  <div className="about-one__content__map">
                    <img
                      src="/assets/images/resources/about-1-map-dark.png?v=20260924"
                      alt="villoz"
                    />
                  </div>
                  <div className="row">
                    <div className="col-lg-5 col-md-6">
                      <div className="about-one__image-one">
                        <img
                          src="/assets/images/main/IMG_2058.webp?v=20260924"
                          alt="villoz"
                        />
                      </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                      <div className="about-one__content-inner">
                        <h5
                          className="about-one__content-inner__title"
                          style={{ color: "#2c4431" }}
                        >
                          A Home Away from Home
                        </h5>
                        <p
                          className="about-one__content-inner__text"
                          style={{ color: "#2c4431" }}
                        >
                          Tucked away in the misty embrace of Kandy's rolling
                          hills, our homestay is your serene escape from the
                          everyday. Wake up to the melody of chirping birds, sip
                          your morning tea with views of lush greenery, and let
                          the mountain breeze rejuvenate your soul. Whether
                          you’re seeking adventure or a peaceful retreat, here’s
                          where nature’s beauty meets heartfelt hospitality.
                        </p>
                        {/* <ul class="about-one__content-inner__list">
                                      <li><span class="fa fa-check-circle"></span>Guarantee happiness</li>
                                      <li><span class="fa fa-check-circle"></span>Search & book the best</li>
                                      <li><span class="fa fa-check-circle"></span>Most luxury villas available</li>
                                      <li><span class="fa fa-check-circle"></span>Premier choice for vacation rentals</li>
                                  </ul> */}
                        <a href="about.html" className="villoz-btn">
                          <i>More About Us</i>
                          <span>More About Us</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.about__image */}
              </div>
              {/* /.col-lg-8 */}
              <div className="col-xl-4 wow fadeInRight" data-wow-delay="300ms">
                <div className="about-one__right">
                  {/* <div class="about-one__circle">
                          <div class="about-one__circle__icon"><span class="icon-best-seller"></span></div>
                          <div class="curved-circle">
                              <div class="curved-circle--item" data-circle-text-options='{
								"radius": 95,
								"forceWidth": true,
								"forceHeight": true
							}'>Top traveler choice villox</div>
                          </div>
                      </div> */}
                  <div className="about-one__image-two">
                    <img
                      src="/assets/images/main/IMG_0712.webp?v=20260924"
                      style={{ height: 700, width: 600 }}
                      alt="villoz"
                    />
                  </div>
                </div>
              </div>
              {/* /.col-lg-4 */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container */}
        </section>
        {/* /.about-one */}
        {/* Rooms preview */}

        <Room />

        {/* Experiences tab */}
        <HanthanaLife />

        {/* /.destination-three */}
        <section
          className="tab-two"
          style={{ backgroundColor: "#ffffff", paddingBottom: 200 }}
        >
          <div className="container tabs-box">
            <div className="row">
              <div className="col-lg-7 col-md-6">
                <div className="sec-title text-left">
                  <h6 className="sec-title__tagline">
                    GET THE BEST EXPERIENCE
                  </h6>
                  <h3 className="sec-title__title">
                    The Only Home You'll Find Outside Of Home
                  </h3>
                </div>
                {/* section-title */}
              </div>
              <div className="col-lg-5 col-md-6">
                {/* <p class="tab-two__text">
                      Powerful corporate social responsibility, grantmaking, and employee engagement strategies.
                      Our impact is about more than moving money to where it’s needed most.
                  </p> */}
              </div>
            </div>
            <div className="row">
              <div className="col-xl-6">
                <ul className="list-unstyled tab-buttons tab-two__list">
                  <li
                    className={`tab-btn ${
                      activeTab === "well_curated_experience"
                        ? "active-btn"
                        : ""
                    }`}
                    onClick={() => setActiveTab("well_curated_experience")}
                  >
                    Sri Lankan Cooking Classes
                  </li>

                  <li
                    className={`tab-btn ${
                      activeTab === "daily_housekeeping" ? "active-btn" : ""
                    }`}
                    onClick={() => setActiveTab("daily_housekeeping")}
                  >
                    Visits to Tea Factories &amp; Tea Estates
                  </li>

                  <li
                    className={`tab-btn ${
                      activeTab === "concierge_services" ? "active-btn" : ""
                    }`}
                    onClick={() => setActiveTab("concierge_services")}
                  >
                    Hanthana Mountain Range Hiking &amp; Trekking
                  </li>

                  <li
                    className={`tab-btn ${
                      activeTab === "dine_drinks" ? "active-btn" : ""
                    }`}
                    onClick={() => setActiveTab("dine_drinks")}
                  >
                    Pekoe Trail
                  </li>
                </ul>
              </div>
              <div className="col-xl-6">
                <div className="tabs-content">
                  {activeTab === "well_curated_experience" && (
                    <div className="tab-two__content fadeInUp animated active-tab">
                      <div className="tab-two__content">
                        <div className="villoz-stretch-element-inside-column">
                          <div className="tab-two__content__img">
                            <img
                              src="/assets/images/activities/cookingclass/1.webp?v=20260924"
                              style={{ maxWidth: 500 }}
                              alt="villoz"
                            />
                          </div>
                        </div>
                        <div className="tab-two__content__info">
                          <div className="tab-two__content__info__top">
                            <h4 className="tab-two__content__info__title">
                              Sri Lankan Cooking Classes
                            </h4>
                            <p className="tab-two__content__info__text">
                              Join Suba at Hanthana House for a hands-on Sri
                              Lankan cooking experience, where you'll learn,
                              cook, and savor authentic flavors!
                            </p>
                          </div>
                          <a
                            className="tab-two__content__info__rm"
                            href="experiences.html"
                          >
                            Read More
                            <span className="icon-right-arrow" />
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === "daily_housekeeping" && (
                    <div className="tab-two__content fadeInUp animated active-tab">
                      <div className="tab-two__content">
                        <div className="villoz-stretch-element-inside-column">
                          <div className="tab-two__content__img">
                            <img
                              src="/assets/images/activities/teafactory/main.webp?v=20260924"
                              style={{ maxWidth: 600 }}
                              alt="villoz"
                            />
                          </div>
                        </div>
                        <div className="tab-two__content__info">
                          <div className="tab-two__content__info__top">
                            <h4 className="tab-two__content__info__title">
                              Visits to Tea Factories &amp; Tea Estates
                            </h4>
                            <p className="tab-two__content__info__text">
                              Discover Sri Lanka’s rich tea heritage with a
                              visit to the Ceylon Tea Museum and Hanthana’s
                              scenic tea estates, where history, culture, and
                              nature blend seamlessly.
                            </p>
                          </div>
                          <a
                            className="tab-two__content__info__rm"
                            href="experiences.html"
                          >
                            Read More
                            <span className="icon-right-arrow" />
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === "concierge_services" && (
                    <div className="tab-two__content fadeInUp animated active-tab">
                      <div className="tab-two__content">
                        <div className="villoz-stretch-element-inside-column">
                          <div className="tab-two__content__img">
                            <img
                              src="/assets/images/activities/hanthanarange/main.webp?v=20260924"
                              style={{ maxWidth: 600 }}
                              alt="villoz"
                            />
                          </div>
                        </div>
                        <div className="tab-two__content__info">
                          <div className="tab-two__content__info__top">
                            <h4 className="tab-two__content__info__title">
                              Hanthana Mountain Range Hiking &amp; Trekking
                            </h4>
                            <p className="tab-two__content__info__text">
                              Embark on a guided trek through the Hanthana
                              Mountain Range, exploring diverse trails,
                              breathtaking landscapes, and rich wildlife on an
                              unforgettable hiking adventure.
                            </p>
                          </div>
                          <a
                            className="tab-two__content__info__rm"
                            href="experiences.html"
                          >
                            Read More
                            <span className="icon-right-arrow" />
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                  {activeTab === "dine_drinks" && (
                    <div className="tab-two__content fadeInUp animated active-tab">
                      <div className="tab-two__content">
                        <div className="villoz-stretch-element-inside-column">
                          <div className="tab-two__content__img">
                            <img
                              src="/assets/images/activities/pekoe/main.webp?v=20260924"
                              style={{ maxWidth: 600 }}
                              alt="villoz"
                            />
                          </div>
                        </div>
                        <div className="tab-two__content__info">
                          <div className="tab-two__content__info__top">
                            <h4 className="tab-two__content__info__title">
                              The Peoke Trail
                            </h4>
                            <p className="tab-two__content__info__text">
                              Experience the beauty of the Pekoe Trail with our
                              expert guides, trekking through tea gardens,
                              forests, and vibrant wildlife, ending in the
                              historic town of Galaha.
                            </p>
                          </div>
                          <a
                            className="tab-two__content__info__rm"
                            href="experiences.html"
                          >
                            Read More
                            <span className="icon-right-arrow" />
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials carousel */}
        <Testimonials />
        {/* Gallery preview */}
        {/* <section className="gallery-one gallery-one--home-one">
          <div className="container">
            <div
              className="gallery-one__carousel villoz-owl__carousel  villoz-owl__carousel--basic-nav owl-carousel owl-theme"
              data-owl-options='{
			"items": 5,
			"margin": 20,
			"loop": false,
			"smartSpeed": 700,
			"nav": false,
			"navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
			"dots": false,
			"autoplay": true,
			"responsive": {
				"0": {
					"items": 1
				},
				"576": {
					"items": 2
				},
				"992": {
					"items": 3
				},
				"1200": {
					"items": 4
				},
				"1500": {
					"items": 5
				}
			}
			}'
            >
              <div className="item">
                <div className="gallery-one__card">
                  <img src="/assets/images/gallery/16.webp?v=20260924" alt="" />
                  <div className="gallery-one__card__hover">
                    <a
                      href="/assets/images/gallery/16.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-one__card__icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="gallery-one__card">
                  <img src="/assets/images/gallery/6.webp?v=20260924" alt="" />
                  <div className="gallery-one__card__hover">
                    <a
                      href="/assets/images/gallery/6.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-one__card__icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="gallery-one__card">
                  <img src="/assets/images/gallery/10.webp?v=20260924" alt="" />
                  <div className="gallery-one__card__hover">
                    <a
                      href="/assets/images/gallery/10.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-one__card__icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="gallery-one__card">
                  <img src="/assets/images/gallery/18.webp?v=20260924" alt="" />
                  <div className="gallery-one__card__hover">
                    <a
                      href="/assets/images/gallery/18.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-one__card__icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="gallery-one__card">
                  <img src="/assets/images/gallery/24.webp?v=20260924" alt="" />
                  <div className="gallery-one__card__hover">
                    <a
                      href="/assets/images/gallery/24.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-one__card__icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="gallery-one__card">
                  <img src="/assets/images/gallery/20.webp?v=20260924" alt="" />
                  <div className="gallery-one__card__hover">
                    <a
                      href="/assets/images/gallery/20.webp?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-one__card__icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* /.gallery-one__carousel */}
        {/* </div> */}
        {/* /.container-fluid */}
        {/* </section> */}
      </main>
      <Footer />
    </>
  );
}

export default Home;
